import runAction from "../../actions/run-action";
import getCurrentLayer from "./current-value/get-current-layer";
import fillAppliedInitials from "./fill-applied-initials";
import fillOrderArray from "./fill-order-array";
import getAppliedInitials from "./get-applied-initials";
import getOrderAndActiveParent from "./get-order-and-active-parent";

/**
 *
 * @param {*} initials
 * @param {Map<String, any>} activeParent
 * @param {*} isInitial
 * @param {MainClassProps} main
 * @param {String} parent
 * @returns {[Array<String>, String, String]}
 */
const getAllLayersResult = (
  initials,
  activeParent,
  isInitial,
  main,
  parent
) => {
  /** Array with final strings */
  let final = [];

  /** Property divider */
  let divider = "";

  /** Property priority (global from whole parent) */
  let priority = "";

  /** Ordered array. (property defined by <order: *>) option */
  const ordered = /** @type {Array<String>} */ ([]);

  /** Unordered (default) array */
  const unordered = /** @type {Array<String>} */ ([]);

  /** Applied initials */
  const applied = /** @type {Map<String, Map<String, String>>} */ (
    main.appliedInitials
  );

  /** Loop initial properties */
  for (const [fn, property] of initials) {
    /**
     * Skip the properties that are not currently active.
     * @example `transform` has `scale` and `translateX`, but only the `scale` is active. Skip the `translateX`
     */
    if (!activeParent?.has(fn) && !isInitial) {
      continue;
    }

    /** Property is initial action */
    if (property.get("is-action")) {
      runAction(property, main);
      continue;
    }

    divider = property.get("divider");

    /** Get `order`, `priority` and `path` of active parent */
    const data = getOrderAndActiveParent(activeParent, property, fn);
    const order = data.get("order");
    const path = data.get("path");

    if (data.get("priority")) {
      priority = "important";
    }

    const layers = /** @type {LayersProps} */ (property.get("layers"));
    const isSafariInitial = property.get("is-safari-initial");

    for (const layer of layers) {
      const flats = /** @type {StorageItemFlatProps} */ (layer.get("flat"));

      for (const flat of flats) {
        const current = getCurrentLayer(flat, path, isInitial, isSafariInitial);

        /** Fill `ordered` and `unordered` arrays */
        fillOrderArray(order, ordered, unordered, current);

        /** Set `appliedInitials` if any, then remove the ones that are no longer active */
        getAppliedInitials(applied, parent, fn, current, isInitial);
      }
    }
  }

  /** Fill the `unordered` array with a rest applied initials */
  fillAppliedInitials(parent, applied, unordered, isInitial);

  if (ordered.length) {
    final = ordered.filter((item) => item).concat(unordered);
  } else {
    final = unordered;
  }

  return [final, divider, priority];
};

export default getAllLayersResult;
